export const HANDLE_API_CALLS = '@handleAPICalls/HANDLE_API_CALLS';
export const HANDLE_API_CALLS_CITY_DATA = '@handleAPICalls/HANDLE_API_CALLS_CITY_DATA';
export const HANDLE_SEED_API_CALLS = '@handleAPICalls/HANDLE_SEED_API_CALLS';
export const HANDLE_CREATE_API_CALLS = '@handleAPICalls/HANDLE_CREATE_API_CALLS';
export const HANDLE_API_CALLS_PARTNER = '@handleAPICallsPartner/HANDLE_API_CALLS_PARTNER';
export const LOGOUT_USER = '@handleAPICalls/LOGOUT_USER';
export const CLEAR_STATE = '@handleAPICalls/CLEAR_STATE';
export const HANDLE_VM_LIST = '@handleAPICalls/HANDLE_VM_LIST';
export const HANDLE_VM_DETAILS = '@handleAPICalls/HANDLE_VM_DETAILS';
export const HANDLE_COHORTS_LIST = '@handleAPICalls/HANDLE_COHORTS_LIST';
export const HANDLE_COHORTS_DETAILS = '@handleAPICalls/HANDLE_COHORTS_DETAILS';
export const HANDLE_WAREHOUSE_LIST = '@handleAPICalls/HANDLE_WAREHOUSE_LIST';
export const HANDLE_WAREHOUSE_DETAILS = '@handleAPICalls/HANDLE_WAREHOUSE_DETAILS';
export const HANDLE_COHORTS_SEED_DATA = '@handleAPICalls/HANDLE_COHORTS_SEED_DATA';
export const HANDLE_PATCH_COHORTS_BASIC = '@handleAPICalls/HANDLE_PATCH_COHORTS_BASIC';
export const HANDLE_UPDATE_VM = '@handleAPICalls/HANDLE_UPDATE_VM';
export const HANDLE_UPLOAD_IMG_API = '@handleAPICalls/HANDLE_UPLOAD_IMG_API';
export const HANDLE_DELETED_VM = '@handleAPICalls/HANDLE_DELETED_VM';




// WEBPACK FOOTER //
// ./src/Modules/HandleAPICalls/constants.js